import React, { useState, useCallback, useEffect } from "react";
import {
  SearchOutlined,
  DeleteOutlined,
  DownloadOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import { toast } from "react-toastify";
import axiosInstance from "../../AxiosInstance";
import { t } from "i18next";
import {
  Input,
  DatePicker,
  Select,
  Breadcrumb,
  AutoComplete,
  Image,
} from "antd";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import { URLS } from "../../API/API endpoints";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import UploadMediaonly from "../../components/upload-imageonly";
import LoadingSpinner from "../../components/Loading";

/* -------------------------------------------
   COMPONENT
--------------------------------------------*/
const CreateHamper = ({ onClose, handleReferesh, editRecord }) => {
  const { t, i18n } = useTranslation();
  const userData = useSelector((state) => state?.login?.user?.result);
  const [hamperNameEn, setHamperNameEn] = useState(
    editRecord ? editRecord?.english_name : "",
  );
  const [hamperNameAr, setHamperNameAr] = useState(
    editRecord ? editRecord?.arabic_name : "",
  );
  const [barcode, setBarcode] = useState(editRecord ? editRecord?.barcode : "");
  const [quantity, setQuantity] = useState(
    editRecord ? editRecord?.quantity : "",
  );
  const [shortCode, setShortCode] = useState(
    editRecord?.short_code ? editRecord?.short_code : "",
  );
  const [imageFile, setImageFile] = useState(null);
  const [imageURL, setImageURL] = useState(
    editRecord?.image_url ? editRecord?.image_url : null,
  );

  const [searchValue, setSearchValue] = useState("");
  const [searchByShortCode, setSearchByShortCode] = useState(false);

  const [productList, setProductList] = useState([]);
  const [originalProducts, setOriginalProducts] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [Productoptions, setProductoptions] = useState([]);
  const [value, setValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isFileValid, setIsFileValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  console.log("imageURL==>", imageURL);
  useEffect(() => {
    if (imageFile && isFileValid === false) {
      // getInventoryKPI();
      setImageFile("");
      setImageURL("");
    }
  }, [isFileValid, imageFile]);

  useEffect(() => {
    if (editRecord?.hamper_id) {
      GetHamperProducts(editRecord);
    }
  }, [editRecord]);

  const GetHamperProducts = async (order) => {
    try {
      const payload = {
        company_id: userData?.company_id,
        hamper_id: order.hamper_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await axiosInstance.post(URLS.GET_HAMPER_ITEMS, payload);

      if (res?.data?.result[0]?.status_code === 200) {
        setProductList(res?.data?.result[0]?.data || []);
        setOriginalProducts(res?.data?.result[0]?.data || []);
      } else {
        setProductList([]);
        setOriginalProducts([]);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      //   setDrawerLoading(false);
    }
  };

  /* -------------------------------------------
     SEARCH PRODUCTS (DEBOUNCE)
  --------------------------------------------*/
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const searchProducts = useCallback(
    debounce(async (value) => {
      getProducts(value);
    }, 500),
    [],
  );

  const getShortCodeProducts = async (val = "") => {
    //   setLoading(true);
    try {
      let payload = {
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        short_code: val,
        type: "all", //required // all or low or high or out
        company_id: userData?.company_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_STOCK_BY_CODE,
        payload,
      );
      if (response?.data?.result[0]?.response) {
        setProductoptions(response?.data?.result[0].response);
      } else {
        setProductoptions([]);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setProductoptions([]);
    } finally {
      // setLoading(false);
    }
  };

  const getProducts = async (val = "") => {
    //   setLoading(true);
    try {
      const payload = {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
        category_id: false,
        product_name: val,
        limit: 10,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await axiosInstance.post(URLS.GET_ALL_PRODUCTS, payload);
      //   console.log("PRIODYCYD", res);

      const result = res?.data?.result[0]?.response || [];
      setProductoptions(result);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProductoptions([]);
    } finally {
      // setLoading(false);
    }
  };

  /* -------------------------------------------
     ADD PRODUCT
  --------------------------------------------*/
  const handleProductSelect = (value) => {
    const selectedProduct = Productoptions.find(
      (product) => product.product_name === value,
    );

    if (selectedProduct) {
      // Check if the product has a barcode
      if (!selectedProduct.barcode) {
        // If no barcode, open the modal to input the barcode
        setSelectedProduct(selectedProduct);
        setSelectedProductId(selectedProduct.quant_id);
        return; // Exit the function to prevent adding the product
      }
    }

    if (selectedProduct) {
      // Check if the product is already in the productList
      const isDuplicate = productList.some(
        (product) => product.quant_id === selectedProduct.quant_id, // Assuming prod_id is unique
      );

      if (isDuplicate) {
        // Optionally, show a message to the user
        toast.error(`${selectedProduct.product_name} is already in the list.`); // Replace with a more user-friendly message or modal if needed
        return;
      }

      const productWithQty = {
        ...selectedProduct,
        sale_price: selectedProduct.current_price,
      };
      setSelectedProduct(productWithQty);
      setProductList([...productList, productWithQty]);
      // setSearchQuery("");
      // setProductoptions([]);
    }
  };

  /* -------------------------------------------
     CHANGE PRODUCT FIELD
  --------------------------------------------*/
  const handleChange = (index, key, value) => {
    const updated = [...productList];
    updated[index][key] = value;
    setProductList(updated);
  };

  /* -------------------------------------------
     REMOVE PRODUCT
  --------------------------------------------*/
  const handleDelete = (id) => {
    const updated = productList.filter(
      (p) => p.product_id !== id && p.quant_id !== id,
    );

    setProductList(updated);
  };

  const CheckHamerDublication = async (val) => {
    try {
      const payload = {
        company_id: userData?.company_id,
        ...(val.hamper_id && { hamper_id: val.hamper_id }),
        english_name: val.hamperNameEn,
        arabic_name: val.hamperNameAr,
        barcode: barcode,
        short_code: val.shortCode,
      };
      const res = await axiosInstance.post(
        URLS.CHECK_HAMPER_DUBLICATION,
        payload,
      );
      return res?.data;
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    } finally {
    }
  };

  /* -------------------------------------------
     SAVE HAMPER
  --------------------------------------------*/
  const handleSave = async () => {
    try {
      if (!hamperNameEn || !hamperNameAr) {
        toast.error(t("Enter gift hamper name"));
        return;
      }
      if (!barcode || barcode == "") {
        toast.error(t("Enter barcode"));
        return;
      }
      if (!quantity || quantity == "") {
        toast.error(t("Enter quantity"));
        return;
      }
      if (productList.length === 0) {
        toast.error(t("Add at least one product"));
        return;
      }

      const missingFields = productList.find(
        (p) =>
          p.sale_price === "" ||
          p.sale_price === null ||
          p.sale_price === undefined ||
          Number(p.sale_price) <= 0 ||
          p.qty_added === "" ||
          p.qty_added === null ||
          p.qty_added === undefined ||
          Number(p.qty_added) <= 0,
      );

      if (missingFields) {
        toast.error(t("Sale price and quantity are required for all items"));
        return;
      }

      const invalidSalePrice = productList.find(
        (p) => Number(p.sale_price) < Number(p.current_cost_price),
      );

      if (invalidSalePrice) {
        toast.error(t("Sale price cannot be less than cost price"));
        return;
      }

      // ❌ Qty added must not exceed available qty
      const invalidQty = productList.find(
        (p) => Number(p.qty_added) > Number(p.system_quantity),
      );

      if (invalidQty) {
        toast.error(t("Quantity cannot exceed available stock"));
        return;
      }
      setLoading(true);
      const isValid = await CheckHamerDublication({
        hamperNameEn: hamperNameEn,
        hamperNameAr: hamperNameAr,
        quantity: Number(quantity),
        barcode,
        shortCode: shortCode,
      });
      if (isValid?.result[0]?.status_code != 200) {
        setLoading(false);
        toast.error(t(isValid?.result[0]?.status));
        return;
      }
      const totalCost = productList.reduce(
        (sum, p) =>
          sum + Number(p.current_cost_price || 0) * Number(p.qty_added || 0),
        0,
      );

      const totalSalePrice = productList.reduce(
        (sum, p) => sum + Number(p.sale_price || 0) * Number(p.qty_added || 0),
        0,
      );
      const payload = {
        company_id: userData?.company_id,
        english_name: hamperNameEn,
        arabic_name: hamperNameAr,
        quantity: Number(quantity),
        barcode,
        short_code: shortCode,
        image_url: imageURL,
        total_cost: Number(totalCost),
        sale_price: Number(totalSalePrice),
        items: productList.map((p) => ({
          product_id: p.quant_id,
          cost_price: Number(p.current_cost_price),
          qty_available: Number(p.system_quantity),
          sale_price: Number(p.sale_price),
          qty_added: Number(p.qty_added),
        })),
      };
      const res = await axiosInstance.post(URLS.CREATE_HAMPER, payload);
      if (res?.data?.result[0]?.status_code == 200) {
        toast.success(t(res?.data?.result[0]?.status));
        handleCancel();
        handleReferesh();
      } else {
        toast.error(t(res?.data?.result[0]?.status));
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      setLoading(false);
    }
  };
  console.log("productList", productList);

  const handleUpdateHamper = async () => {
    try {
      if (!hamperNameEn || !hamperNameAr) {
        toast.error(t("Enter gift hamper name"));
        return;
      }

      if (productList.length === 0) {
        toast.error(t("Add at least one product"));
        return;
      }

      const missingFields = productList.find(
        (p) =>
          p.sale_price === "" ||
          p.sale_price === null ||
          p.sale_price === undefined ||
          Number(p.sale_price) <= 0 ||
          p.qty_added === "" ||
          p.qty_added === null ||
          p.qty_added === undefined ||
          Number(p.qty_added) <= 0,
      );

      if (missingFields) {
        toast.error(t("Sale price and quantity are required for all items"));
        return;
      }

      const invalidSalePrice = productList.find(
        (p) => Number(p.sale_price) < Number(p.current_cost_price),
      );

      if (invalidSalePrice) {
        toast.error(t("Sale price cannot be less than cost price"));
        return;
      }

      // ❌ Qty added must not exceed available qty
      const invalidQty = productList.find(
        (p) => Number(p.qty_added) > Number(p.system_quantity),
      );

      if (invalidQty) {
        toast.error(t("Quantity cannot exceed available stock"));
        return;
      }
      setLoading(true);
       const isValid = await CheckHamerDublication({
        hamperNameEn: hamperNameEn,
        hamperNameAr: hamperNameAr,
        quantity: Number(quantity),
        hamper_id: editRecord?.hamper_id,
        barcode,
        shortCode: shortCode,
      });
      if (isValid?.result[0]?.status_code != 200) {
        setLoading(false);
        toast.error(t(isValid?.result[0]?.status));
        return;
      }
      const totalCost = productList.reduce(
        (sum, p) =>
          sum + Number(p.current_cost_price || 0) * Number(p.qty_added || 0),
        0,
      );

      const totalSalePrice = productList.reduce(
        (sum, p) => sum + Number(p.sale_price || 0) * Number(p.qty_added || 0),
        0,
      );

      const deletedItems = originalProducts
        .filter(
          (op) => !productList.some((p) => p.product_id === op.product_id),
        )
        .map((op) => ({
          id: op.id, // important for backend
          product_id: op.product_id ? op.product_id : op.quant_id,
          cost_price: op.cost_price
            ? Number(op.cost_price)
            : Number(op.current_cost_price || 0),
          qty_available: op.qty_available
            ? Number(op.qty_available)
            : Number(op.system_quantity || 0),
          sale_price: Number(op.sale_price || 0),
          qty_added: Number(op.qty_added || 0),
          is_delete: true,
        }));

      const payload = {
        company_id: userData?.company_id,
        hamper_id: editRecord?.hamper_id,
        english_name: hamperNameEn,
        arabic_name: hamperNameAr,
        barcode,
         short_code: shortCode,
        quantity: Number(quantity),
        image_url: imageURL,
        total_cost: Number(totalCost),
        sale_price: Number(totalSalePrice),
        items: [
          ...productList.map((p) => ({
            ...(p.id && { id: p.id }),
            product_id: p.product_id ? p.product_id : p.quant_id,
            cost_price: p.cost_price
              ? Number(p.cost_price)
              : Number(p.current_cost_price),
            qty_available: p.qty_available
              ? Number(p.qty_available)
              : Number(p.system_quantity),
            sale_price: Number(p.sale_price),
            qty_added: Number(p.qty_added),
            is_delete: false,
          })),
          ...deletedItems,
        ],
      };
      console.log("payload==>", payload);

      const res = await axiosInstance.post(URLS.UPDATE_HAMPER_DETAILS, payload);
      if (res?.data?.result[0]?.status_code == 200) {
        toast.success(t(res?.data?.result[0]?.status));
        handleCancel();
        handleReferesh();
      } else {
        toast.error(t(res?.data?.result[0]?.status));
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------------------
     CANCEL
  --------------------------------------------*/
  const handleCancel = () => {
    setHamperNameEn("");
    setHamperNameAr("");
    setBarcode("");
    setProductList([]);
    setImageFile(null);
    setImageURL(null);
    onClose();
  };

  const isSalePriceInvalid = (p) =>
    Number(p.sale_price) < Number(p.current_cost_price);

  const isQtyInvalid = (p) => Number(p.qty_added) > Number(p.system_quantity);
  console.log("image url==>", imageURL);

  return (
    <div className="w-full min-h-screen  bg-[#F6F7F9]">
      {/* Header */}
      {loading && <LoadingSpinner />}
        {imageLoading && <LoadingSpinner />}
      <div className="flex justify-between items-center px-2">
        <h2 className="text-xl font-semibold">
          {editRecord?.hamper_id ? t("Update Gift Hamper") : t("Create Gift Hamper")}
        </h2>
        
        <div className="flex gap-3">
          <button
            onClick={handleCancel}
            className="px-6 h-10 border rounded-lg bg-white"
          >
            {t("Cancel")}
          </button>

          <button
            disabled={imageLoading}
            onClick={() => {
              if (editRecord) {
                handleUpdateHamper();
              } else {
                handleSave();
              }
            }}
            className="px-6 h-10 rounded-lg bg-primaryBlue text-white disabled:opacity-50"
          >
            {t("Save")}
          </button>
        </div>
      </div>

      {/* Card */}
      <div className="bg-white mx-2 my-4 p-6 rounded-lg border">
        {/* Top Row */}
        <div className="flex gap-6">
          <div className="w-9/12">
            <div className=" flex justify-between gap-x-3">
              <span className="block leading-[0px] w-6/12">
                <InputBox
                  label={t("Hamper Name (EN)")}
                  //   className={`${
                  //     formik.errors.secondaryBarcode ? "border-red" : ""
                  //   }`}
                  name="englishName"
                  placeholder={t("Enter Hamper Name")}
                  onChange={(e) => {
                    setHamperNameEn(e.target.value);
                  }}
                  value={hamperNameEn}
                  maxLength={30}
                />
              </span>
              <span className="block leading-[0px] w-6/12">
                <InputBox
                  label={t("Hamper Name (AR)")}
                  //   className={`${
                  //     formik.errors.secondaryBarcode ? "border-red" : ""
                  //   }`}
                  name="arabicName"
                  placeholder={t("Enter Arabic Name")}
                  onChange={(e) => {
                    setHamperNameAr(e.target.value);
                  }}
                  value={hamperNameAr}
                  maxLength={30}
                />
              </span>
              </div>
            <div className=" flex justify-between gap-x-3">
              <span className="block leading-[0px] w-4/12">
                <InputBox
                  label={t("Barcode")}
                  // type="number"
                  name="arabicName"
                  placeholder={t("Enter Barcode")}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setBarcode(value);
                    }
                  }}
                  value={barcode}
                  maxLength={14}
                />
              </span>
              <span className="block leading-[0px] w-4/12">
                <InputBox
                  label={t("Quantity")}
                  // type="number"
                  name="quantity"
                  placeholder={t("Enter Quantity")}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Always allow clearing
                    if (value === "") {
                      setQuantity("");
                      return;
                    }

                    // Remove any non-digit characters
                    const sanitized = value.replace(/[^0-9]/g, "");

                    setQuantity(sanitized);
                  }}
                  value={quantity}
                  maxLength={5}
                />
              </span>
               <span className="block leading-[0px] w-4/12">
                <InputBox
                  label={t("Product Short Code")}
                  // type="number"
                  name="shortCode"
                  placeholder={t("Enter Product Short Code")}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Always allow clearing
                    if (value === "") {
                      setShortCode("");
                      return;
                    }

                    // Remove any non-digit characters
                    const sanitized = value.replace(/[^0-9]/g, "");

                    setShortCode(sanitized);
                  }}
                  value={shortCode}
                  maxLength={10}
                />
              </span>
            </div>
            <div className="w-full flex mt-6 gap-x-2">
              <span className="relative w-full">
                <AutoComplete
                  value={value}
                  style={{ width: "100%", height: 50, outline: "none" }}
                  open={dropdownOpen}
                  onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                  options={Productoptions?.map((prod) => ({
                    value: prod.product_name,
                    label: (
                      <div className="flex justify-between items-center">
                        <span>{prod.product_name}</span>
                        {productList.some(
                          (p) => p.quant_id === prod.quant_id,
                        ) && (
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#16A34A"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </div>
                    ),
                    disabled: productList.some(
                      (p) =>
                        p.quant_id === prod.quant_id ||
                        p.product_id === prod.quant_id,
                    ),
                  }))}
                  filterOption={false}
                  onSearch={(val) => {
                    setValue(val);
                    if (searchByShortCode) {
                      if (val.length >= 1) {
                        getShortCodeProducts(val);
                      } else {
                        setProductoptions([]);
                      }
                    } else {
                      if (val.length >= 2) {
                        searchProducts(val);
                        setDropdownOpen(true); // keep open while typing
                      } else {
                        setProductoptions([]);
                        setDropdownOpen(false);
                      }
                    }
                  }}
                  onSelect={(val) => {
                    handleProductSelect(val);
                    setValue("");

                    // Delay a tick to reopen dropdown
                    setTimeout(() => setDropdownOpen(true), 0);
                  }}
                >
                  <Input
                    placeholder={
                      searchByShortCode
                        ? t("Search Short Code")
                        : t("search_product")
                    }
                    size="large"
                    style={{
                      borderColor: "#d9d9d9", // remove border
                      boxShadow: "none", // remove hover/focus glow
                    }}
                    suffix={
                      value ? (
                        <CloseOutlined
                          onClick={() => {
                            setValue("");
                            setDropdownOpen(true); // keep dropdown open after clearing
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <SearchOutlined />
                      )
                    }
                  />
                </AutoComplete>
              </span>
              <button
                type="button"
                onClick={() => {
                  setValue("");
                  setProductoptions([]);
                  setSearchByShortCode(!searchByShortCode);
                }}
                className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap ${
                  searchByShortCode
                    ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                    : "bg-white border-gray-300 text-gray-700"
                }`}
              >
                {t("Search Code")}
              </button>
            </div>
          </div>
          {/* Upload */}
          <div className=" w-3/12 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer">
            {imageFile ? (
              <img
                src={imageFile}
                height={60}
                width={60}
                alt="prod"
                style={{
                  minWidth: "9rem",
                  maxWidth: "10rem",
                  maxHeight: "7rem",
                  minHeight: "6rem",
                }}
              />
            ) : imageURL ? (
              <img
                src={imageURL}
                height={60}
                width={60}
                alt="Uploaded"
                style={{
                  minWidth: "9rem",
                  maxWidth: "10rem",
                  maxHeight: "7",
                  minHeight: "6rem",
                }}
              />
            ) : (
              <svg
                className=" float-left h-10 w-12 text-gray-300"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                />
              </svg>
            )}
            <span className="cursor-pointer">
              <UploadMediaonly
                foldername={"store_image"}
                onfileAdd={"hamperimage" + "-" + Date.now()}
                setBase64Images={setImageFile}
                urlgenerated={(val) => setImageURL(val?.url)}
                imageurl={imageURL ? imageURL : ""}
                setIsFileValid={setIsFileValid}
                setImageLoading={setImageLoading}
              />
            </span>
          </div>
          {/* <div className=" w-3/12 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer">
            <DownloadOutlined className="text-xl text-primaryBlue mb-1" />

            <p className="text-primaryBlue font-medium">
              {t("Upload Hamper Image")}
            </p>

            <span className="text-xs text-gray-400">{t("(Optional)")}</span>

            <input type="file" hidden onChange={handleImage} />
          </div> */}
        </div>

        {/* Search */}

        {/* Table */}
        {productList.length > 0 && (
          <div className="border rounded-lg mt-8">
            <table className="w-full text-sm text-gray-800">
              <thead className="bg-gray-100">
                <tr className="font-medium">
                  <th className="p-3 text-left font-medium text-gray-900">
                    {t("Barcode")}
                  </th>
                  <th className="p-3 text-left font-medium text-gray-900">
                    {t("Product Name")}
                  </th>
                  <th className="p-3 text-left w-[140px] font-medium text-gray-900">
                    {t("Cost Price")}
                  </th>
                  <th className="p-3 text-left w-[140px] font-medium text-gray-900">
                    {t("Original Sale Price")}
                  </th>
                  <th className="p-3 text-left w-[140px] font-medium text-gray-900">
                    {t("Quantity Available")}
                  </th>
                  <th className="p-3 w-[120px] font-medium text-gray-900">
                    {t("Sale Price for Hamper")}
                  </th>

                  <th className="p-3 w-[120px font-medium text-gray-900]">
                    {t("Quantity Added")}
                  </th>
                  <th className="p-3 font-medium text-gray-900">
                    {t("Action")}
                  </th>
                </tr>
              </thead>

              <tbody>
                {productList.map((p, i) => (
                  <tr key={i} className="border-t">
                    <td className="p-3">{p.barcode}</td>
                    <td className="p-3 ">
                      {p.product_name2 && p.product_name2 != ""
                        ? p.product_name2
                        : p.product_name}
                    </td>
                    <td className="p-3 w-[140px]">
                      EGP{" "}
                      {p.cost_price
                        ? p.cost_price.toFixed(2)
                        : p.current_cost_price.toFixed(2)}
                    </td>
                    <td className="p-3 w-[120px]">
                      EGP{" "}
                      {p.product_sale_price
                        ? p.product_sale_price.toFixed(2)
                        : p.current_price?.toFixed(2)}
                    </td>
                    <td className="p-3 w-[140px]">
                      {p.qty_available || p.system_quantity}
                    </td>
                    <td className="p-3 w-[120px]">
                      <Input
                        value={p.sale_price}
                        status={isSalePriceInvalid(p) ? "error" : ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            value == "" ||
                            (/^\d*\.?\d{0,2}$/.test(value) && value.length <= 5)
                          ) {
                            handleChange(i, "sale_price", e.target.value);
                          }
                        }}
                      />
                    </td>

                    <td className="p-3 w-[120px]">
                      <Input
                        value={p.qty_added}
                        status={isQtyInvalid(p) ? "error" : ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          const isUnit =
                            p.uom === "Units" || p.uom === "الوحدات";

                          const wholeNumberRegex = /^[0-9]*$/; // integers only
                          const decimalRegex = /^\d*\.?\d{0,2}$/; // up to 2 decimals
                          if (isUnit && value == ".") {
                            handleChange(i, "qty_added", "");
                            return;
                          }
                          if (
                            value === "" ||
                            (isUnit && wholeNumberRegex.test(value)) ||
                            (!isUnit && decimalRegex.test(value))
                          ) {
                            handleChange(i, "qty_added", value);
                          }
                        }}
                      />
                    </td>

                    <td className="p-3 text-center">
                      <DeleteOutlined
                        onClick={() =>
                          handleDelete(
                            p?.product_id ? p?.product_id : p?.quant_id,
                          )
                        }
                        className="text-red-500 cursor-pointer"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateHamper;
